module.exports = __webpack_public_path__ + "img/Christian.aea94d99.png";